import {
  ChangeDetectionStrategy,
  Component,
  inject,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { menuBar } from '@softapps/core';
import { PageComponent } from '@softapps/core/pages';
import { title } from '@softline/application';
import { DynamicModule } from '@softline/dynamic';
import { TranslatePipe, translator } from '@softline/ui-core';

interface SelectedCustomer {
  id?: number;
  nummer?: number | string;
}

@Component({
  selector: 'soft-kundenabfrage-customer-query',
  templateUrl: './customer-query.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, PageComponent, DynamicModule, TranslatePipe],
})
export class CustomerQueryComponent {
  private readonly router = inject(Router);
  private readonly t = translator();

  readonly pageTitle = title('#CUSTOMER.TITLE');
  readonly menuBarTemplate = viewChild.required('menuBarTemplate', {
    read: TemplateRef,
  });

  constructor() {
    menuBar({
      key: 'softapps/wws/kundenabfrage',
      title: this.t('#CUSTOMER.TITLE'),
      template: this.menuBarTemplate,
      align: 'leading',
      containerStyle: 'plain',
      separated: true,
      grow: true,
    });
  }

  async selectCustomer(customer: SelectedCustomer | null): Promise<void> {
    if (!customer?.id) return;
    await this.router.navigate(['/kundenabfrage', customer.id], {
      queryParams: { nummer: customer.nummer },
    });
  }
}
